import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { AuditHolder } from 'src/app/core-module/models/Audits/audit-holder';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { Question } from 'src/app/core-module/models/Audits/question';
import { AuditLocation } from 'src/app/core-module/models/Locations/audit-location';
import { UserLocationSave } from 'src/app/core-module/models/user-location-save';
import { UserLocation } from 'src/app/core-module/models/UserManagement/user-location';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { AuditGuidService } from 'src/app/core-module/services/audits/audit-guid.service';
import { AuditValidationService } from 'src/app/core-module/services/audits/audit-validation.service';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { LocalStorageService } from 'src/app/core-module/services/local-storage.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
  selector: 'app-incomplete-panel',
  templateUrl: './incomplete-panel.component.html',
  styleUrls: ['./incomplete-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class IncompletePanelComponent {
  @Input() auditInput: UserLocationSave;
  @Input() linkedAudit: UserLocationSave = new UserLocationSave();

  @Output() Refresh = new EventEmitter();




  public location: AuditLocation;
  public readyForDelete: UserLocationSave[] = [];
  public currentlyDeleting: boolean = false;
  public auditCounter: string = "";
  public auditStarted: string = "";
  public incompleteQuestions: number = 0;
  public hasReference: boolean = false;
  public reference: string = "";
  public hasRemainingQuestions: boolean = false;
  public remainingQuestions: number = 0;
  public auditStartedAgo: string = "";
  public totalQuestions: number = 0;
  public totalCompletedQuestions: number = 0;

  public auditEditAgo: string = "";
  public auditEdit: string = "";

  public hasAlt: boolean = false;
  public altAuditEditAgo: string = "";
  public altAuditEdit: string = "";

  public showDelete: boolean = false;
  public showCloudWarning: boolean = false;

  public username: string = "";

  constructor(public util: UtilService, public auditValidation: AuditValidationService, private router: Router, private auditService: AuditService, private authService: AuthService, private toast: ToastrService, private localStorage: LocalStorageService) {

  }
  ngOnInit() {
    this.initialise();
  }
  initialise() {
    var auditDetail = this.auditInput.FlattenedQuestions[0]
    this.auditCounter = this.auditValidation.auditCounter(auditDetail)
    this.auditStarted = this.util.humanDate(auditDetail.AuditCompletionInfo.StartedDate);
    this.incompleteQuestions = this.auditValidation.remainingQuestions(auditDetail);
    this.hasReference = this.hasReferenceQuestion(auditDetail);
    if (this.hasReference) {
      this.reference = this.getReference(auditDetail);
    }
    this.hasRemainingQuestions = this.auditValidation.remainingQuestions(auditDetail, true) > 0;
    if (this.hasRemainingQuestions) {
      this.remainingQuestions = this.auditValidation.remainingQuestions(auditDetail, true);
    }
    this.auditStartedAgo = this.util.humanDateDistance(auditDetail.AuditCompletionInfo.StartedDate);
    this.auditEdit = this.util.humanDateTime(this.auditInput.LastUpdate);
    this.auditEditAgo = this.util.humanDateDistance(this.auditInput.LastUpdate);
    this.getUsername();
    if (this.linkedAudit.AuditGUID.length > 0) {
      this.hasAlt = true;
    }
    this.getCompletionTotals()
  }
  getCompletionTotals() {
    this.totalCompletedQuestions = 0;
    this.totalQuestions = 0;
    this.auditInput.FlattenedQuestions[0].Questions.forEach(e => {
      if (e.QuestionType.ID != 6 && !e.NASelected) {
        this.totalQuestions++;
        if (e.CompletionInfo.QuestionAnswered) {
          this.totalCompletedQuestions++;
        }
      }
    });
  }

  get completionProgressScore(): number {
    return this.totalQuestions === 0 ? 1 : this.totalCompletedQuestions;
  }

  get completionProgressMaximum(): number {
    return this.totalQuestions === 0 ? 1 : this.totalQuestions;
  }

  setLocalDates() {
    this.altAuditEdit = this.util.humanDateTime(this.linkedAudit.LastUpdate);
    this.altAuditEditAgo = this.util.humanDateDistance(this.linkedAudit.LastUpdate);
  }
  getUsername() {
    this.authService.getUserName()
      .pipe(
        tap((a: any) => {
          this.username = a.Username;
        })
      )
      .subscribe();

  }
  jumpToAudit() {
    //save local version
    console.log('input', this.auditInput);
    if (this.auditInput.CloudSave) {
      console.log('cloud save')
      this.updateLocal();
    }

    this.router.navigateByUrl('audit', { state: { "SavedAudit": this.auditInput.FlattenedQuestions[0], "SavedLocation": this.auditInput.Location, "AuditGUID": this.auditInput.AuditGUID } });
  }


  updateLocal() {
    this.auditInput.LastUpdate = new Date();
    this.auditInput.LastUpdateSet = true;
    this.auditInput.CloudSave = false;
    if (this.username == null) {
      return;
    }
    var localData: any;
    this.auditService.getALLLocalAudits()
      .pipe(
        tap((a: UserLocationSave[]) => {
          localData = a;
        })
      )
      .subscribe();
    if (localData == null) {

      var saveList: UserLocationSave[] = [];
      saveList.push(this.auditInput);
      this.localStorage.setData(2, saveList);

    } else {
      var parsedData: UserLocationSave[] = <UserLocationSave[]>localData;
      var currentSet: UserLocationSave = new UserLocationSave();
      var localDataIndex = parsedData.findIndex((e) => {
        return e.Username.toLowerCase() == this.username.toLowerCase() && e.AuditGUID == this.auditInput.AuditGUID;
        //return e.Username == username && e.Location.LocationID == this.location.LocationID && e.FlattenedQuestions[0].AuditID == this.currentData.AuditID;
      });
      if (localDataIndex != -1) {
        currentSet = parsedData.find((f) => {
          return f.Username.toLowerCase() == this.username.toLowerCase() && f.AuditGUID == this.auditInput.AuditGUID;
          //return f.Username == username && f.Location.LocationID == this.location.LocationID && f.FlattenedQuestions[0].AuditID == this.currentData.AuditID;
        })!;
        if (currentSet.FlattenedQuestions.some((g) => { return g.AuditID == this.auditInput.FlattenedQuestions[0].AuditID; })) {
          var tempQuestions: Question[] = [];
          this.auditInput.FlattenedQuestions[0].Questions.forEach(e => {
            tempQuestions.push(new Question(e));
          })
          currentSet.FlattenedQuestions.find((h) => {
            return h.AuditID == this.auditInput.FlattenedQuestions[0].AuditID;
          })!.Questions = tempQuestions;
          currentSet.LastUpdate = new Date();
          currentSet.LastUpdateSet = true;
        } else {
          currentSet = this.auditInput;
          parsedData.push(currentSet);
        }
      } else {
        parsedData.push(this.auditInput);
      }
      this.localStorage.setData(2, parsedData);
    }
  }

  checkAudit() {
    if (!this.hasAlt) {
      this.jumpToAudit();
    } else {
      console.log('linkedAudit', this.linkedAudit);
      this.setLocalDates();
      this.showCloudWarning = true;
    }
  }
  switchDeleteStatus() {
    this.showDelete = !this.showDelete;
  }

  changeDeleteConfirmStatus(auditDetails: UserLocationSave) {
    if (this.readyForDelete.some(e => e.FlattenedQuestions[0].AuditID == auditDetails.FlattenedQuestions[0].AuditID && e.Location.LocationID == auditDetails.Location.LocationID)) {
      var index: number = this.readyForDelete.findIndex(f => f.FlattenedQuestions[0].AuditID == auditDetails.FlattenedQuestions[0].AuditID && f.Location.LocationID == auditDetails.Location.LocationID)
      this.readyForDelete.splice(index, 1);
    } else {
      this.readyForDelete.push(auditDetails);
    }
  }
  onDeleteList(auditDetails: UserLocationSave): boolean {
    if (this.readyForDelete.some(e => e.AuditGUID == auditDetails.AuditGUID)) {
      return true;
    } else {
      return false;
    }
  }
  forceLocalLoad() {
    this.router.navigateByUrl('audit', { state: { "SavedAudit": this.linkedAudit.FlattenedQuestions[0], "SavedLocation": this.linkedAudit.Location, "AuditGUID": this.linkedAudit.AuditGUID } });
  }
  hasReferenceQuestion(audit: FlattenedQuestionHolder): boolean {
    var returnValue = false;
    var firstValueFound = false;
    audit.Questions.forEach(e => {
      if (e.IsReference && !firstValueFound) {
        firstValueFound = true;
        if (e.CompletionInfo.QuestionAnswered) {
          returnValue = true;
        }
      }
    })
    return returnValue;
  }
  getReference(audit: FlattenedQuestionHolder): string {
    var returnValue = "";
    var firstValueFound = false;
    audit.Questions.forEach(e => {
      if (e.IsReference && !firstValueFound) {
        firstValueFound = true;
        if (e.CompletionInfo.QuestionAnswered) {
          returnValue = this.getQuestionAnswerString(e);
        }
      }
    });
    return returnValue;
  }
  getQuestionAnswerString(q: Question): string {
    var returnValue = "";
    if (q.QuestionType.ID == 4) {
      returnValue == q.CompletionInfo.Answer
    }
    if (q.QuestionType.ID == 1 || q.QuestionType.ID == 2) {

      q.QuestionAnswers.forEach(e => {
        if (e.QuestionAnswerID == q.CompletionInfo.Answer) {
          returnValue = e.AnswerText;
        };
      });
    }
    return returnValue;
  }
  removeAudit() {
    this.currentlyDeleting = true;
    this.auditService.removeLocalAudit(this.auditInput.AuditGUID, this.username);
    this.auditService.removeAudit(this.auditInput.AuditGUID).pipe(tap(res => {
      console.log('[Remove Audit] API response:', res);
      this.currentlyDeleting = false;
      this.toast.addToastr(new Toastr({ Type: 2, Message: "Audit removed." }));
      this.Refresh.emit();
    })).subscribe();

    //this.confirmDelete = false;
  }
  readyToSubmit(FQH: FlattenedQuestionHolder): string[] {
    var textHolder: string[] = [];
    var nonCompliantQuestions = this.auditValidation.incompleteNonCompliant(FQH);
    var required: number = this.auditValidation.remainingQuestions(FQH, true);
    if (required > 0) {
      if (required == 1) {
        textHolder.push("1 required question to complete");
      } else {
        textHolder.push(required + " required questions to complete");
      }

    }
    if (nonCompliantQuestions.length > 0) {
      if (nonCompliantQuestions.length == 1) {
        textHolder.push(nonCompliantQuestions.length + " question requires actions to be raised");
      } else {
        textHolder.push(nonCompliantQuestions.length + " questions that require additional actions to be raised");
      }

    }

    /*var returnText = "";
    textHolder.forEach(e => {
      if (returnText.length > 0) {
        returnText += " "
      }
      returnText += e
    }
    )*/
    //x actions need to be added
    if (textHolder.length == 0) {
      textHolder.push("None");
    }
    return textHolder;
  }

}
